<template>
  <div class="content">
    <NavbarInstrument></NavbarInstrument>
    <v-main>
      <v-container fluid>
        <v-card>
          <template v-slot:title>
            Aplicación Instrumento de Evaluación
          </template>
          <template v-slot:subtitle>
            <div>{{ name }} <v-chip color="primary">{{ type }}</v-chip> - {{ beneficiary.name }} {{ beneficiary.lastname }}</div>
          </template>
          <template v-slot:text>
            <div>{{ description }}</div>
            <div class="mb-5">A continuación, podrás encontrar un conjunto de preguntas de selección múltiple con única respuesta, por favor contesta cada una de ellas:</div>
            <v-form ref="form">
              <div class="mb-3" v-for="question in questions" :key="question.id">
                <div>{{ question.pregunta }}</div>
                <v-radio-group v-model="answers[question.id].answers" :rules="[v => !!v || 'Por favor seleeciona una opción de respuesta.']">
                  <v-radio v-for="(a, i) in onFilter(question)" :key="i" :label="a[0]" :value="{q: a[0], p: a[1]}"></v-radio>
                </v-radio-group>
                <hr>
              </div>
              <div class="text-center">
                <v-btn color="primary" @click="onSend()">Enviar</v-btn>
              </div>
            </v-form>
          </template>
        </v-card>
      </v-container>
      
    </v-main>  
    <!-- Process -->
    <v-dialog v-model="process" max-width="320" persistent >
      <v-list class="py-2" color="primary" elevation="12" rounded="lg" >
        <v-list-item prepend-icon="mdi-clock" title="Espera..." >
          <template v-slot:prepend>
            <div class="pe-4">
              <v-icon color="primary" size="x-large"></v-icon>
            </div>
          </template>
          <template v-slot:append>
            <v-progress-circular color="primary" indeterminate="disable-shrink" size="16" width="2" />
          </template>
        </v-list-item>
      </v-list>
    </v-dialog>
    <!-- validate -->
    <v-dialog v-model="enroll" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-comment-question" size="70" />
        <h2 class="text-h5 mb-3">{{ name }} - {{ type }}</h2>
        <p class="m-4 text-medium-emphasis text-body-2">
          Por favor ingresa tu número de documento:
        </p>
        <div class="text-center">
          <v-text-field v-model="document" color="primary" variant="outlined" :disabled="loading" :rules="rulesdocument"></v-text-field>
          <v-btn variant="tonal" color="primary" :disabled="loading" :loading="loading" @click="onValidate">Buscar</v-btn>
        </div>
      </v-sheet>
    </v-dialog>
    <!-- error -->
    <v-dialog v-model="error.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-close-circle" size="112" />
        <h2 class="text-h5 mb-6">Error</h2>
        <p class="mb-4 text-medium-emphasis text-body-2" v-html="error.text"></p>
        <v-divider class="mb-4"></v-divider>
        <div class="text-end">
          <v-btn class="text-none" color="error" variant="flat" text="Aceptar" @click="error.state = false"/>
        </div>
      </v-sheet>
    </v-dialog>
    <!-- failed -->
    <v-dialog v-model="failed.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-calendar-remove" size="112" />
        <h2 class="text-h5 mb-3">Parece que ha ocurrido un error</h2>
        <p class="m-4 text-medium-emphasis text-body-2">
          {{  failed.text  }}
        </p>
        <div class="text-center">
          <v-btn class="text-none" color="error" variant="plain" prepend-icon="mdi-open-in-new" text="www.unitedwaycolombia.org" @click="openlink('https://unitedwaycolombia.org')"/>
        </div>
      </v-sheet>
    </v-dialog>
  </div>
</template>
<script setup>
  import axios from 'axios';
  import Params from '@/models/params';
  import NavbarInstrument from '@/components/navbar/NavbarInstrument.vue';
  import { ref, reactive } from 'vue';

  const name = localStorage.instrumentName;
  const type = localStorage.instrumentType;
  const instrument = localStorage.instrumentId;
  const assessment = localStorage.instrumentAssesment;
  const description = localStorage.instrumentDescription;
  const process = ref(false);
  const loading = ref(false);
  const enroll = ref(true);
  const form = ref()
  const document = ref(null);
  const questions = ref([]);
  const answers = ref([]);
  const params = ref(new Params);

  const failed = reactive({
    state: null,
    text: null
  })

  const error = reactive({
    state: null,
    text: null
  })

  const beneficiary = ref({
    enroll: 0,
    name: null,
    lastname: null,
    document: null
  });

  const rulesdocument = [
    value => {
      const pattern = /^\d{7,15}$/
      return pattern.test(value) || 'Invalid document.'
    }
  ]

  function onFilter(question){
    return question.respuestas.filter(respuesta => respuesta[0]); 
  }

  async function onValidate(){
    if (document.value) {
      loading.value = true;
      const frm = new FormData;
      frm.append('document', document.value);
      frm.append('assessment', assessment);
      await axios.post(params.value.api + 'instrumentos/beneficiario', frm)
      .then( r => {
        enroll.value = false;
        if (r.data.status) {
          const d = r.data.data;
          beneficiary.value.enroll = d.idmatricula;
          beneficiary.value.name = d.nombres;
          beneficiary.value.lastname = d.apellidos;
          beneficiary.value.document = d.documento_numero;
          loading.value = false;
          loadQuestions();
        }else{
          failed.text = r.data.message;
          failed.state = true;
        }
      })
      .catch( (err) => {
        failed.text = err.message;
        failed.state = true;
      });
    }
  }

  async function loadQuestions() {
    try {
      process.value = true;
      const frm = new FormData;
      frm.append('instrument', instrument);
      await axios.post(params.value.api + 'instrumentos/preguntas', frm)
      .then( r => {
        if(r.data.status){
          const d = r.data.data;
          d.forEach(e => {
            const random = sortAnswers([ 
              [e.opcion1, e.peso1], 
              [e.opcion2, e.peso2], 
              [e.opcion3, e.peso3], 
              [e.opcion4, e.peso4], 
              [e.opcion5, e.peso5] 
            ])
            questions.value.push({
              id: e.id,
              codigo: e.codigo,
              nivel: e.idnivel,
              idpregunta: e.idpregunta,
              pregunta: e.pregunta,
              tipo: e.tipo,
              respuestas: random,
              respuesta: []
            });           
            answers.value[e.id] = {
              level: e.idnivel,
              question: e.idpregunta,
              answers: null,
            };
          });       
        }else{
          failed.text = r.data.message;
          failed.state = true;
        }        
      });
      process.value = false;
    } catch (err) {
      failed.text = err;
      failed.state = true;
    }
  }

  async function onSend() {
    const { valid } = await form.value.validate()
    if (valid){
      console.log(answers.value);
    } else {
      error.text = 'Existe una o más preguntas por responder.';
      error.state = true;
    }
  }

  function sortAnswers(opciones) {
    return opciones.sort(() => Math.random() - 0.5);
  }
</script>